// @flow
import { all } from "redux-saga/effects";
import homeSagas from "../containers/App/sagas";
import tokenSaga from '../config/msal/TokenSaga';
import businessPartnerDetailsSagas from "../containers/BusinessPartnerDetails/sagas";
import rejectedBusinessPartnersSagas from "../containers/RejectedBusinessPartners/saga";
import businessPartnerListsSagas from "../containers/BusinessPartnerLists/saga";
import notificationSagas from "../containers/Notification/sagas";
import changeLogSagas from "../containers/ChangeLog/sagas";
import stewardBusinessPartnerListsSagas from "../containers/StewardBusinessPartnerLists/saga";

function* rootSaga() {
  yield all([
    ...homeSagas,
    ...tokenSaga,
    ...businessPartnerDetailsSagas,
    ...rejectedBusinessPartnersSagas,
    ...businessPartnerListsSagas,
    ...notificationSagas,
    ...changeLogSagas,
    ...stewardBusinessPartnerListsSagas
  ]);
}

export default rootSaga;
